import { OrderInfoInterface } from './orderInfo/state';
import { store } from 'quasar/wrappers';
import Vuex, {Store} from 'vuex';
import { UserStateInterface } from './user/state';
import user from './user';
import setting from './setting';
import layout from './layout';

import { SettingStateInterface } from './setting/state';
import { LayoutStateInterface } from './layout/state';
import orderInfo from './orderInfo';



/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

let AppStore: Store<StateInterface>;

export interface StateInterface {
  // Define your own store structure, using submodules if needed
  user: UserStateInterface;
  setting: SettingStateInterface;
  layout: LayoutStateInterface;
  orderInfo: OrderInfoInterface;
}

export default store(function ({ Vue }) {
  Vue.use(Vuex);

  const appStore = new Vuex.Store<StateInterface>({
    modules: {
      user,
      setting,
      layout,
      orderInfo,
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: !!process.env.DEBUGGING
  });

  AppStore = appStore;

  return AppStore;
});

export { AppStore };